export const BLAST_GROUPS_INTERNAL_NAMES = {
  FIRST_IMPRESSION: 'first_impression',
  REACTIVATE: 'reactivate',
  SPECIAL_OCCASIONS: 'special_occasions',
  OWN_MESSAGE: 'own_message',
}

export const BLAST_STATUSES = {
  STATUS_INACTIVE: 'I',
  STATUS_ACTIVE: 'A',
}

export const DATE_HOURS_VALUES = {
  MORNING: 8,
  AFTERNOON: 12,
  EVENING: 16,
}

export const OWN_MESSAGE_DAFAULTS = {
  title: '',
  body: '',
  body_short: '',
  image: null,
  date_hour: 8,
  channel_priority: {
    default: true,
    sms: false,
    prefer_push: false,
    push: false,
    email: false,
  },
}

export const SEARCH_BY_BOOKING = 'search_by_booking'

export const OWN_MESSAGE_INTERNAL_NAME = 'own_message'

export const MESSAGE_BLASTS_ENTRY_SOURCE = {
  MARKETING_TAB: 'marketing_tab',
  PROMOTIONS: 'promotions',
  CLIENTS_GROUPS: 'clients_groups',
  CLIENT_DETAILS: 'client_details',
  DEEPLINK: 'deeplink',
  TARGET_TYPE: 'target_type',
}
